export default (loanApplicationId = null) => ({
	loanApplicationId,
	loanAmount: null,
	loanPurposeConfigurationId: null,
	additionalComments: '',
	branchPreferencesConfigurationId: null
});
